import React from 'react'

interface ITwitter {
  width?: string
  height?: string
}

const Twitter: React.FC<ITwitter> = ({ width = '26', height = '22' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.4107 2.81362C25.0023 2.99476 24.5823 3.14766 24.1532 3.27182C24.6612 2.69728 25.0486 2.02128 25.285 1.28155C25.338 1.11575 25.2831 0.934263 25.1468 0.825795C25.0106 0.717276 24.8215 0.704276 24.6717 0.793092C23.7604 1.33355 22.7773 1.72198 21.7464 1.94907C20.708 0.934416 19.2977 0.356934 17.8396 0.356934C14.762 0.356934 12.2581 2.86074 12.2581 5.93828C12.2581 6.18066 12.2735 6.42171 12.3038 6.65942C8.48479 6.32411 4.93428 4.44699 2.49618 1.45624C2.4093 1.34965 2.27544 1.29217 2.13838 1.30319C2.00127 1.3139 1.87803 1.39124 1.80876 1.51012C1.31426 2.35862 1.05283 3.3291 1.05283 4.31654C1.05283 5.66142 1.53297 6.9374 2.38117 7.93448C2.12325 7.84516 1.873 7.73354 1.63413 7.60095C1.5059 7.52955 1.3494 7.53067 1.22199 7.60369C1.09453 7.67677 1.0146 7.81108 1.01119 7.95794C1.01059 7.98267 1.01058 8.0074 1.01058 8.03249C1.01058 10.0399 2.091 11.8473 3.74286 12.8323C3.60093 12.8181 3.45915 12.7976 3.31823 12.7707C3.17294 12.7429 3.0236 12.7938 2.92564 12.9046C2.82753 13.0153 2.79503 13.1697 2.84028 13.3106C3.45168 15.2195 5.02584 16.6235 6.92886 17.0516C5.35049 18.0402 3.54552 18.558 1.65073 18.558C1.25535 18.558 0.857734 18.5348 0.468599 18.4888C0.275275 18.4658 0.0904324 18.5799 0.0245694 18.7638C-0.0412936 18.9477 0.0285303 19.1528 0.192959 19.2582C2.62715 20.819 5.44174 21.6439 8.33235 21.6439C14.0149 21.6439 17.5698 18.9642 19.5512 16.7163C22.0221 13.9132 23.4391 10.203 23.4391 6.53714C23.4391 6.38398 23.4368 6.22936 23.432 6.07518C24.4069 5.34074 25.2461 4.45187 25.9291 3.43025C26.0328 3.27512 26.0216 3.07001 25.9014 2.92722C25.7815 2.78417 25.5815 2.73796 25.4107 2.81362Z"
      fill="#262A44"
    />
  </svg>
)

export default Twitter
